/*
 * Copyright (c) Castle Point Learning Systems Corporation, 2013-2023, all rights reserved.
 * NOTICE: Dissemination of the information and/or materials contained in this file is strictly
 * forbidden unless prior written permission is obtained from Castle Point Learning Systems Corporation.
 * See LICENSE.txt (part of this package) for the full notice.
 */

import {useCallback, useContext} from "react";
import {EvaluationContext} from "../context/EvaluationContextProvider";

export const useEvaluationEditorBlur = () => {
    const {dispatchEvaluation} = useContext(EvaluationContext);

    return useCallback((blur: boolean) => dispatchEvaluation(prevState => {
        return {...prevState, focused: !blur, nodeIdsNearCursor: undefined}
    }), [dispatchEvaluation])
}